import { FaArrowRight } from "react-icons/fa6"
import { Link } from "react-router-dom"
import { PropTypes } from 'prop-types';

const DiscoverBtn = ({ text, link }) => {
    return (
        <Link to={link} className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex">
            <span className="text-white text-base font-bold capitalize flex items-center gap-3">{text} <FaArrowRight /></span>
        </Link>
    )
}
DiscoverBtn.propTypes = {
    text: PropTypes.string,
    link: PropTypes.string
}
export default DiscoverBtn